import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-content">
                <p>&copy; {new Date().getFullYear()} Pointr®. All rights reserved.</p>
                <div className="footer-links">
                    <a href="https://www.pointr.tech/privacy-policy">Privacy Policy</a>
                    <a href="https://github.com/pointrlabs" target="_blank" rel="noopener noreferrer">GitHub</a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
